import styled from 'styled-components';

export const InfiosLoadingWrapper = styled.div`
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    width: 100vW;
    height: 100vh;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0,0,0, 0.08);
    backdrop-filter: blur(8px);
    z-index: 900;
`;
